import { Stack } from '@mui/material'
import { TitleAttention } from './TitleAttention'

type SectionContainerProps = {
  title: string
  children: React.ReactNode
  isLast?: boolean
}

export const CampaignSectionContainer: React.FC<SectionContainerProps> = ({ title, children, isLast = false }) => {
  return (
    <Stack gap={3} borderBottom={isLast ? 0 : 1} borderColor="divider" pb={isLast ? 0 : 5}>
      <TitleAttention>{title}</TitleAttention>
      <Stack gap={5}>{children}</Stack>
    </Stack>
  )
}
